import { formatMoney, fromString } from '@aeris/money';
/**
 * Pedidos da loja online (F225, F307): o que dizer ao cliente quando o aviso
 * automático não sai, e por que não saiu, nas palavras da vendedora. O site e
 * o celular leem daqui.
 */
export const STORE_ORDER_SKIP_REASONS = {
    no_conversation: 'o cliente não conversou em nenhum número da loja: avise você pelo WhatsApp.',
    outside_window: 'o número oficial só manda mensagem até 24h depois da última do cliente: avise você.',
};
const money = (value) => formatMoney(fromString(value));
/** O que dizer ao cliente quando o aviso não sai sozinho. */
export const storeOrderMessage = (order) => order.status === 'approved'
    ? `Olá! Seu pedido nº ${String(order.number)} foi aprovado: ${money(order.approvedAmount ?? order.totalAmount)}. Já estamos separando.`
    : `Olá! Não conseguimos atender o seu pedido nº ${String(order.number)}: ${order.rejectReason ?? ''}.`;
/** Os motivos prontos para recusar, os mais comuns na loja. */
export const STORE_ORDER_REJECT_PRESETS = [
    'Acabou a peça',
    'Peça errada para o modelo',
    'Fora da área de entrega',
];
//# sourceMappingURL=storefront.js.map